import React, { useContext, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';
import PropTypes from 'prop-types';
import CdnImageBackground from '../common/CdnImageBackground';
import { H3, H5 } from '../text';
import LayoutContext from '../../contexts/Layout';

const Photo = ({
    carouselRef,
    description,
    enableImageOverlay = false,
    image,
    index,
    onPress,
    nodeTypeAlias = 'Photo',
    renderControls = false,
    style,
    textColor,
    title,
    width,
    ...rest
}) => {
    const { layout } = useContext(LayoutContext);
    const [imageDimensions, setImageDimensions] = useState();

    if (!image) {
        return null;
    }

    return (
        <CdnImageBackground
            imageDimensions={imageDimensions}
            setImageDimensions={setImageDimensions}
            style={style}
            uri={image.cdnImagePath}
            width={width}
            key={rest.key}
            dataSet={{ umbracoComponentName: nodeTypeAlias }}
        >
            <View
                onPress={onPress}
                style={StyleSheet.flatten(Styles.contentContainer, { height: imageDimensions?.height, marginHorizontal: layout.styleGuide.spacer2 })}
                dataSet={{ spacerLeft: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`, spacerRight: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
            >
                {renderControls && (
                    <View style={Styles.navigationControls}>
                        <FontAwesome6 color={index === 0 ? 'transparent' : textColor} name='chevron-left' onPress={() => carouselRef?.current?.prev()} size={40} />
                        <FontAwesome6 color={textColor} name='chevron-right' onPress={() => carouselRef?.current?.next()} size={40} />
                    </View>
                )}
                <View
                    style={StyleSheet.flatten(Styles.detailsContainer, { bottom: layout.styleGuide.spacer3 })}
                    dataSet={{ spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }}
                >
                    <H3 style={{ color: textColor || '#fff' }} text={title} />
                    <H5 style={Styles.description} text={description} />
                </View>
            </View>
        </CdnImageBackground>
    );
};

const Styles = StyleSheet.create({
    description: {
        color: '#fff',
        fontFamily: 'GothamBook'
    },
    detailsContainer: {
        color: '#fff',
        position: 'absolute'
    },
    navigationControls: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        top: '40%'
    }
});

Photo.propTypes = {
    onNext: PropTypes.func,
    onPress: PropTypes.func,
    onPrevious: PropTypes.func,
    renderControls: PropTypes.bool,
    title: PropTypes.string,
    imageSrc: PropTypes.string,
    description: PropTypes.string,
    textColor: PropTypes.string,
    link: PropTypes.shape({
        externalUrl: PropTypes.string,
        internalKey: PropTypes.string,
        isExternal: PropTypes.bool
    })
};

export default Photo;
